import { OrdersService } from './../../services/order/orders.service';
import { ActivatedRoute, Router } from '@angular/router';
import { Component } from '@angular/core';
import { WebSiteUsersService } from '@app/services/webSiteUsers/webSiteUsers.service';

@Component({

    selector: 'confirmation-payement',
    templateUrl: 'confirmation-payement.component.html',
    styleUrls: ['confirmation-payement.component.scss']
})
export class ConfirmationPayementComponent {
    error = false;
    loading = true;
    key;
    status=0;
    constructor(
        public route: ActivatedRoute,
        public router: Router,
        private webuser: WebSiteUsersService,
        private orderService: OrdersService
    ) {
        this.route.queryParams.subscribe(params => {
            ;
            this.key = params['trx_id'];
            if (this.key) {
                this.webuser.getPayement(this.key).subscribe(
                    (data: any) => {
                        if (data.status == "AUTHORIZED") {
                            this.webuser.confirmePayement(this.key).subscribe(
                                ()=>{
                                    this.status=1;
                                    this.error = false;
                                    this.loading = false;
                                    this.orderService.clearOrder();
                                    this.orderService.chosenOrderType.next(0);
                                    this.orderService.address.next({
                                        id: null,
                                        address: "",
                                        city: "",
                                        postalCode: null,
                                        streetNumber: null,
                                        streetName: "",
                                    });
                                },
                                ()=>{
                                    this.loading = false;
                                    this.error = true;
                                }
                            )
                        }
                        if (data.status == "CONFIRMED") {
                            this.error = false;
                            this.loading = false;
                            this.status=2;
                        }
                        if (data.status == "TIMED_OUT") {
                            this.error = false;
                            this.loading = false;
                            this.status=3;
                        }
                        if(data.status == "CANCELLED"){
                            this.router.navigate(['/']);
                        }
                    },
                    (err) => {
                        this.loading = false;
                        if(err.status==400){
                            if(err.error.code==2401){
                                this.status=4;
                            }
                        }else{
                            this.error = true;
                        }
                    }
                )
            }
        })
    }
}
